export default "/assets/fonts/Graphik-Semibold.37193cd61618fd8a017e91270963b7d9.woff2";